<template>
    <div id="app">
        <v-app  v-model="show">           
           
            <v-form dense>
                
                <v-card  class="pa-3 yellow lighten-3"    dense>
                    
                        <v-row dense class="mb-0">
                            <v-col cols="12" sm="2" md="1" >
                                <v-text-field dense outlined @keyup.enter="mostrarCabeceraOT(vOT.Otrabajo)"   v-model="vOT.Otrabajo"
                                    label="Nª OT"                        
                                ></v-text-field>                    
                            </v-col>
                            <v-col cols="12" sm="2" md="1" >
                                <v-btn x-small dense  @click="mostrarBuscadorOt(1)">
                                    Buscar OT 
                                </v-btn>                    
                            </v-col>
                            <v-col  cols="12" sm="6" md="3"  >                                                                
                                <v-text-field dense  class="text-md-center red--text"     disabled v-model="vOT.Detalle"
                                    label="Nombre de Orden de Trabajo"                                                   
                                ></v-text-field>                    
                            </v-col>   
                            <v-col  cols="12" sm="6" md="3"  >
                                <v-text-field dense class="text-md-center red--text"     disabled v-model="vOT.Nota1"
                                    label="Nota"                                                   
                                ></v-text-field>                    
                            </v-col> 
                            
                            <v-col cols="2" sm="2" md="2">
                                <v-btn  dense color="success"  @click="ocultarSolicitud()">
                                                                    <!-- <v-icon>mdi-close</v-icon> -->
                                            Volver a Ficha OT
                                </v-btn>

                            </v-col>
                        </v-row>
                        
              
                  
                </v-card>
            </v-form>

                           
            <v-form  dense>
                <v-card class="pa-3 yellow lighten-5"    dense>

                    <v-row >
                        <v-col cols="6" sm="6" md="4">
                            <v-card  class="mb-3 pa-3 card-height">
                                <v-radio-group v-model="flags">                       
                                    <v-radio label="Solicitud de Materiales" value="1" @click="buscarComp(flags)"></v-radio>
                                    <v-radio label="Reemplazo de Materiales" value="3" @click="buscarComp(flags)"></v-radio>
                                    <v-radio label="Anulación de Materiales" value="5" @click="buscarComp(flags)"></v-radio>                       
                                </v-radio-group>
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="6" md="6" v-if="vTipo!=0 && flags!=''">
                            <v-card  class="mb-3 pa-3  card-height" >
                                <v-container class="d-flex align-center justify-center">
                                    <v-select
                                        
                                            :items="comprobante"                                        
                                            v-model="seleccion"
                                            item-text="comprob"
                                            outlined
                                            dense
                                    ></v-select>
                                </v-container>
                            </v-card>
                        </v-col>    
                    </v-row>
                    <v-row class="flex-grow-1 text-right">
                        <v-col cols="6" sm="6" md="6">
                                <v-btn x-small color="primary" :disabled="!flags || !seleccion" @click="imprimir(vOT.Otrabajo, seleccion, flags)">
                                    Aceptar
                                </v-btn>
                        </v-col>
                        <!-- <v-col cols="6" sm="6" md="1">
                            <v-btn x-small color="primary">
                                Cancelar
                            </v-btn>
                        </v-col> -->
                    </v-row>

                </v-card>    
                    
            </v-form>
                        
            

                    
           

            
            <BuscadorOT
            
                :visible="showCarga"
                :pnumot="this.numOT"
                :pnombreot="this.nombreOT"               
                @close="showCarga = false"
                @otSel="vOtSel = $event"
                
            >
            
            </BuscadorOT>

        

        </v-app>



    </div>
</template>

<style button-container scoped>
.button-container {
  display: flex;
  justify-content: left;
  align-items: center;
}
</style>

<script>
import Axios from "../../../axios-auth-sistemas";
import BuscadorOT from "../EI026/BuscadorOT.vue"; 
import moment from "moment";
import readXlsFile from "read-excel-file";
import jsPDF from "jspdf"; 
import "jspdf-autotable";

export default {
    name:'Imprimir',
    data(){
        return{

                    
                      
            search: '',
            showCarga: false,
            numOT:'',
            nombreOT:'',
            flag:'',
            vOtSel:'',
            datos:[],
            vOT:{
                    Otrabajo:'',
                    Detalle:'',
                    Nota1:''
                },  

            vTipo:0,
            comprobante:[],   
            seleccion:'', 
            flags:'',

            desserts3: [],
            desserts4: [],
            

        }
    },

    computed:{

        semana() {
            return (
                this.formatDate(this.date)
            );
        },

    },

    watch: {
        
        vOtSel: function () {
            this.mostrarCabeceraOT(this.vOtSel)
        },

        
       
    }, 

    
    components: { 
    
        BuscadorOT,
         
    },


  
    watch: {
        
        vOtSel: function () {
            
            this.mostrarCabeceraOT(this.vOtSel)
        },

        
       
    },      

    computed: {    
      
        show: {
            get() {
               
                this.flags="";
                this.vOT.Otrabajo ="";
                
            },
            set(value) {
            },
        },  

       
    },

    mounted() {

        this.showCarga=false;
        

       
        if (this.$store.state.otrabajo != "") {
                this.vOT.Otrabajo= this.$store.state.otrabajo;
                this.mostrarCabeceraOT(this.vOT.Otrabajo);
        }
    },  

    created(){
      
    },
    
   

    methods: {

        llamoPrueba(){
            console.log("esto en el compoenete prueba")
           
            this.$parent.step=true;
        },

        llamo(){
           
        },

        cargarVarStore(){

            console.log("ot" + this.vOT.Otrabajo)
            this.datos.ano = this.vOT.Ano  
            this.datos.carpeta = this.vOT.Carpeta  
            this.datos.otrabajo = this.vOT.Otrabajo  
            this.datos.nombre = this.vOT.Detalle  
            this.datos.comercial = this.vOT.RespCom
            this.datos.tecnico = this.vOT.RespTec  
            this.$store.commit('save',this.datos)            
           console.log("ooott" +  this.$store.state.otrabajo)
        },

        mostrarCabeceraOT(id){
                let self = this;              
                self.btnSol=false;
                Axios
                .get("/CtaOtPro/Getnombreot?", {
                params: {
                    id: id,
                },
                })
                .then((r) => {             
                    
                    self.btnSol=true;
                    self.vOT.Otrabajo = r.data[0].otrabajo
                    self.vOT.Detalle = r.data[0].detalle
                    self.vOT.Nota1 = r.data[0].nota1
                    self.cargarVarStore()
                    
                    self.flags="";
                    self.vTipo="0";
                    self.flags="0";

                       
                       
                })
                .catch((error) => {
                
                    console.log("error")      
                    
                                
                }); 

        },

        
        
        
        pruebaMensaje(){
            
        //    this.$swal("", "Se genero exitosamente la Solicitud de Materiales", "info")
        // this.$swal("Borrado", "Se borro exitosamente", "warning")
        // this.$swal("Borrado", "Se borro exitosamente", "error")
        //this.$swal("Borrado", "Se borro exitosamente", "question")
        //this.$swal("Borrado", "Se borro exitosamente", "success")

        
        },
        
        

        
        mostrarBuscadorOt(bandera){
              
            // this.$router.push({name:'BuscadorOT'})
            console.log("click en")
                this.numOT = "";
                this.nombreOT = "";            
                this.showCarga = true
                this.flag= bandera;
                if (this.$store.state.ot_sel != "") {
                   
                    this.vOT.Otrabajo= this.$store.state.otrabajo;
                    this.mostrarCabeceraOT(this.vOT.Otrabajo);
            }

        },


        buscarComp(flag){
            this.comprobante=[];
            console.log(flag)
            this.vTipo= flag;
            Axios
                .get("/SolicitudEI026/GetComprobOT?", {
                params: {
                    id: this.vOT.Otrabajo,
                    id1: this.vTipo
                },
                })
                .then((r) => {
                    
                    this.comprobante = r.data;
                    
                    

                       
                       
                })
                .catch((error) => {
                    
                    console.log("error")      
                                
                }); 

        },

        imprimir(ot,comp,flag){

            console.log(ot)
            console.log(comp)
            console.log(flag)
            let self = this; 

            self.desserts3=[];
            self.desserts4=[];

            /*Solicitud*/
            if (flag == "1"){

                Axios
                    .get("/SolicitudEI026/GetEI026PDF2?", {
                        params: {
                            id: ot , 
                            id1: comp,
                            id2:'1'
                        },
                    })
                    .then((response) => {     

                            response.data.forEach(element => {
                                console.log(element.item)                        
                                self.desserts3.push({
                                    item: element.item,
                                    articulo: element.articulo,
                                    cantPres: element.cantPres,
                                    cantidad: element.cantidad,
                                    comercial: element.comercial,
                                    comprob: element.comprob,
                                    detalle: element.detalle,
                                    fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                    fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                    ff: element.ff,
                                    iitem: element.iitem,
                                    ins: element.ins,
                                    itemIns: element.itemIns,
                                    lugEnt: element.lugEnt,
                                    moneda: element.moneda,
                                    nombre: element.nombre,
                                    nota: element.nota,
                                    observa: element.observa,
                                    otrabajo: element.otrabajo,
                                    precioPre: element.precioPre,
                                    renglon: element.renglon,
                                    seguimiento: element.seguimiento,
                                    tipoMat: element.tipoMat,
                                    unidad: element.unidad,
                                    tecnico: element.tecnico,
                                })
                            });

                            
                            console.log("PDF1")
                            console.log(self.desserts3)
                            
                            

                            self.generarPDF(flag);


                    })
                    .catch(r => {
                        console.log("error !")
                    });

                }
            
            /*Reemplazo*/    
            if (flag == "3") {                       
                console.log("datosss reemplazados" )
               
                Axios
                .get("/SolicitudEI026/LinkEI026?", {
                    params: {
                        id: ot , 
                        id1: comp,
                        id2: '3'
                    },
                })
                .then((response) => {       

                    console.log("datosss treemp" )
                    console.log(response)              
                    response.data.forEach(element => {
                            if(element.recibida == null || element.recibida == 0) {

                                    self.desserts3.push({
                                    recibida: element.recibida,
                                    devuelto: element.devuelto,
                                    item: element.item,
                                    articulo: element.articulo,
                                    detalle: element.detalle,
                                    cantidad: element.estado == '3' ? '' : element.cantidad,
                                    unidad: element.unidad,
                                    tipoMat: element.tipoMat,
                                    unidad: element.unidad,
                                    fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                    fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                    comprob: element.comprob,
                                    moneda: element.moneda,
                                    precioPre: element.precioPre,
                                    cantPres: element.cantPres,
                                    comercial: element.comercial,
                                    tecnico: element.tecnico,                                
                                    ff: element.ff == 'N' ? "" : element.ff,
                                    iitem: element.iitem,
                                    ins: element.ins,
                                    seguimiento: element.seguimiento,
                                    observa: element.observa,                            
                                    itemIns: element.itemsIns,                            
                                    lugEnt: element.lug_Ent,
                                    otrabajo: this.$store.state.otrabajo,
                                    nombre: this.$store.state.nombreot,
                                    nota: element.nota

                                })
                                            
                            }
                            else
                            {

                                self.desserts4.push({
                                    recibida: element.recibida,
                                    devuelto: element.devuelto,
                                    item: element.item,
                                    articulo: element.articulo,
                                    detalle: element.detalle,
                                    cantidad: element.estado == '3' ? '' : element.cantidad,
                                    unidad: element.unidad,
                                    tipoMat: element.tipoMat,
                                    unidad: element.unidad,
                                    fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                    fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                    comprob: element.comprob,
                                    moneda: element.moneda,
                                    precioPre: element.precioPre,
                                    cantPres: element.cantPres,
                                    comercial: element.comercial,
                                    tecnico: element.tecnico,                                
                                    ff: element.ff == 'N' ? "" : element.ff,
                                    iitem: element.iitem,
                                    ins: element.ins,
                                    seguimiento: element.seguimiento,
                                    observa: element.observa,                            
                                    itemIns: element.itemsIns,                            
                                    lugEnt: element.lug_Ent,
                                    nota: element.nota,
                                    otrabajo: this.$store.state.otrabajo,
                                    nombre: this.$store.state.nombreot

                                })


                            }


                        });                       
                       self.generarPDF(flag);


                })
                .catch(r => {
                    console.log("error !")
                });

           }

           /*Anulacion*/
           if (flag == "5"){
           
                   
                self.desserts3=[];
           
                Axios
                .get("/SolicitudEI026/LinkEI026?", {
                    params: {
                        id: ot , 
                        id1: comp,
                        id2: flag
                    },
                })
                .then((response) => {       
                        response.data.forEach(element => {                  
                                self.desserts3.push({
                                recibida: element.recibida,
                                devuelto: element.devuelto,
                                item: element.item,
                                articulo: element.articulo,
                                detalle: element.detalle,
                                cantidad: element.cantidad,
                                unidad: element.unidad,
                                tipoMat: element.tipoMat,
                                unidad: element.unidad,
                                fecha_nec: element.item == null ? ""  : moment(element.fecha_nec).format("DD/MM/YYYY"),
                                fecha_ped: element.item == null ? ""  : moment(element.fecha_ped).format("DD/MM/YYYY"),
                                comprob: element.comprob,
                                moneda: element.moneda,
                                precioPre: element.precioPre,
                                cantPres: element.cantPres,
                                comercial: element.comercial,
                                tecnico: element.tecnico,                                
                                ff: element.ff == 'N' ? "" : element.ff,
                                iitem: element.iitem,
                                ins: element.ins,
                                seguimiento: element.seguimiento,
                                observa: element.observa,                            
                                itemIns: element.itemsIns,                            
                                lugEnt: element.lug_Ent,
                                otrabajo: this.$store.state.otrabajo,
                                nombre: this.$store.state.nombreot,
                                nota: element.nota

                            })                                       
                    });

                        
                        console.log("PDF1")
                        console.log(self.desserts3)                  
                        self.generarPDF(flag);


                })
                .catch(r => {
                    console.log("error !")
                });
                     
           } 

        },


     

        generarPDF(flag){
           let self = this; 

           console.log(self.desserts3);
           console.log(self.desserts4);
           if (flag == "1"){
                var vm = this;      
                var columns = [
                {title: "IT", dataKey: "item"},
                {title: "Código", dataKey: "articulo"},
                {title: "FF", dataKey: "ff"},
                {title: "I-P", dataKey: "ins"},
                {title: "Critico", dataKey: "seguimiento"},
                {title: "Cant.", dataKey: "cantidad"},
                {title: "Un.", dataKey: "unidad"},
                {title: "Descripcion", dataKey: "detalle"},
                {title: "Tipo", dataKey: "tipoMat"},
                {title: "Mon.", dataKey: "moneda"},
                {title: "Cant. Pres.", dataKey: "cantPres"},  
                {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
                {title: "Fecha Nec.", dataKey: "fecha_nec"},
                

                ];
                var doc = new jsPDF();
                doc.setLineWidth(0.5);
                doc.line(10, 11, 200, 11);           
                doc.line(10, 11, 10, 41);
                doc.line(165, 24, 200, 24);
                doc.line(165, 33, 200, 33);
                doc.addImage(
                    "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",
                    "JPEG",
                    15,
                    15,
                    22,
                    22
                );
                doc.setFontSize(13);
                doc.text("PLANILLA DE MATERIALES" , 75, 20);
                doc.setFontSize(12);
                doc.text("SOLICITUD N° " + vm.desserts3[0].comprob  , 80, 26);
                doc.setFontSize(8);
                doc.text("Descripción: " +vm.desserts3[0].nombre , 42, 33);
                doc.text("Nota: " +vm.desserts3[0].nota , 42, 38);
                doc.setFontSize(14);
                doc.text("OT N°: " + this.$store.state.otrabajo , 166, 20);
                doc.line(40, 11, 40, 41);
                doc.setFontSize(10);
                doc.text("Fecha: " +vm.desserts3[0].fecha_ped , 166, 30);           
                doc.setFontSize(11);
                doc.text("EI026 Rev. 5" , 170, 38);
                doc.line(40, 11, 40, 41);
                doc.line(165, 11, 165, 41);
                doc.line(10, 41, 200, 41);
                doc.line(200, 11, 200, 41);
                doc.setFontSize(10);
            
            
                doc.autoTable(columns, this.desserts3, {
                theme: 'grid',     
                startY: 45,
                margin: { top: 25, left: 10 , right: 10},
                styles: { fontSize: 7 }
                
                });

            

                var finalO =  doc.autoTable.previous.finalY + 30;

                if (finalO >= 285) {
                    doc.addPage();
                    finalO = 0;
                }

                doc.setFontSize(11);
                doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 20 );            
                doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 26 )          
                doc.text("Observaciones:  " + vm.desserts3[0].observa , 10,finalO + 32 );     
                doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
                doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 51);
                const pageCount = doc.internal.getNumberOfPages();

                for (var i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.text(
                    "Página " + String(i) + " de " + String(pageCount),
                    210 - 20,
                    297 - 10,
                    null,
                    null,
                    "right"
                    );
                }

                doc.save('table.pdf');

           }
           
           if (flag == "3") {

                var vm = this;      
                var columns = [
                {title: "IT", dataKey: "item"},
                {title: "Código", dataKey: "articulo"},
                {title: "Cant.", dataKey: "cantidad"},
                {title: "Un.", dataKey: "unidad"},
                {title: "FF", dataKey: "ff"},            
                {title: "I-P", dataKey: "ins"},
                {title: "Descripcion", dataKey: "detalle"},
                {title: "Critico", dataKey: "seguimiento"},        
                {title: "Cant. Pres.", dataKey: "cantPres"},  
                {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
                {title: "Fecha Nec.", dataKey: "fecha_nec"},           
                ];

                var columns1 = [               
                    {title: "IT", dataKey: "item"},
                    {title: "Código", dataKey: "articulo"},
                    {title: "Cant.", dataKey: "cantidad"},
                    {title: "Un.", dataKey: "unidad"},
                    {title: "FF", dataKey: "ff"},            
                    {title: "I-P", dataKey: "ins"},
                    {title: "Descripcion", dataKey: "detalle"},
                    {title: "Critico", dataKey: "seguimiento"},
                    {title: "Item Nvo", dataKey: "devuelto"},
                    {title: "Cant. Pres.", dataKey: "cantPres"},  
                    {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
                    {title: "Fecha Nec.", dataKey: "fecha_nec"},      
                ];    

                var doc = new jsPDF();
                doc.setLineWidth(0.5);
                doc.line(10, 11, 200, 11);           
                doc.line(10, 11, 10, 41);
                doc.line(165, 24, 200, 24);
                doc.line(165, 33, 200, 33);
                doc.addImage(
                    "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",
                    "JPEG",
                    15,
                    15,
                    22,
                    22
                );
                doc.setFontSize(13);
                doc.text("PLANILLA DE MATERIALES" , 75, 20);
                doc.setFontSize(12);
                doc.text("Reemplazo N° " + vm.desserts3[0].comprob  , 80, 26);
                doc.setFontSize(8);
                doc.text("Descripción: " +vm.desserts3[0].nombre , 42, 33);
                doc.text("Nota: " +vm.desserts3[0].nota , 42, 38);
                doc.setFontSize(14);
                doc.text("OT N°: " + this.$store.state.otrabajo , 166, 20);
                doc.line(40, 11, 40, 41);
                doc.setFontSize(10);
                doc.text("Fecha: " +vm.desserts3[0].fecha_ped , 166, 30);         
                doc.setFontSize(11);
                doc.text("EI026 Rev. 5" , 170, 38);
                doc.line(40, 11, 40, 41);
                doc.line(165, 11, 165, 41);
                doc.line(10, 41, 200, 41);
                doc.line(200, 11, 200, 41);
                doc.setFontSize(10);
            
                doc.setTextColor("red");
                doc.text("NUEVOS MATERIALES ", 75,46 );

                doc.autoTable({
                theme: 'grid', 
                columns: columns,
                body: this.desserts3,
                startY: 48,
                margin: { top: 25, left: 10, right: 10 },
                styles: { fontSize: 7 },          
                });

                var finalO =  doc.autoTable.previous.finalY + 30;

                if (finalO >= 285) {
                    doc.addPage();
                    finalO = 0;
                }


                doc.setTextColor("red");
                doc.text("MATERIALES REEMPLAZADOS", 75,doc.autoTable.previous.finalY + 8 );
                    
                doc.autoTable({
                theme: 'grid',    
                columns: columns1,
                body: this.desserts4,
                startY: doc.autoTable.previous.finalY + 10,
                margin: { top: 25, left: 10, right: 10 },
                styles: { fontSize: 7 }
                });


                var finalO =  doc.autoTable.previous.finalY + 30;

          
                doc.setFontSize(11);
                
              

                doc.setTextColor("black");
                doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 20 );            
                doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 26 )          
                doc.text("Observaciones:  " + vm.desserts3[0].observa , 10,finalO + 32 );     
                doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
                doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 51);



            
            
                
        
                const pageCount = doc.internal.getNumberOfPages();

                for (var i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.text(
                    "Página " + String(i) + " de " + String(pageCount),
                    210 - 20,
                    297 - 10,
                    null,
                    null,
                    "right"
                    );
                }

                doc.save('table.pdf');

           }
           
           if (flag == "5"){

                var vm = this;      
                var columns = [
                {title: "IT", dataKey: "item"},
                {title: "Código", dataKey: "articulo"},
                {title: "Cant. Anulada", dataKey: "cantidad"},
                {title: "Un.", dataKey: "unidad"},
                {title: "FF", dataKey: "ff"},            
                {title: "I-P", dataKey: "ins"},
                {title: "Descripcion", dataKey: "detalle"},
                {title: "Critico", dataKey: "seguimiento"},        
                {title: "Cant. Pres.", dataKey: "cantPres"},  
                {title: "Precio Unit. Pres.", dataKey: "precioPre"},                            
                {title: "Fecha Nec.", dataKey: "fecha_nec"},           
                ];           

                var doc = new jsPDF();
                doc.setLineWidth(0.5);
                doc.line(10, 11, 200, 11);           
                doc.line(10, 11, 10, 41);
                doc.line(165, 24, 200, 24);
                doc.line(165, 33, 200, 33);
                doc.addImage(
                    "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",
                    "JPEG",
                    15,
                    15,
                    22,
                    22
                );
                doc.setFontSize(13);
                doc.text("PLANILLA DE MATERIALES" , 75, 20);
                doc.setFontSize(12);
                doc.text("Anulación N° " + vm.desserts3[0].comprob  , 80, 26);
                doc.setFontSize(8);
                doc.text("Descripción: " +vm.desserts3[0].nombre , 42, 33);
                doc.text("Nota: " +vm.desserts3[0].nota , 42, 38);
                doc.setFontSize(14);
                doc.text("OT N°: " + this.$store.state.otrabajo , 166, 20);
                doc.line(40, 11, 40, 41);
                doc.setFontSize(10);
                doc.text("Fecha: " +vm.desserts3[0].fecha_ped , 166, 30);         
                doc.setFontSize(11);
                doc.text("EI026 Rev. 5" , 170, 38);
                doc.line(40, 11, 40, 41);
                doc.line(165, 11, 165, 41);
                doc.line(10, 41, 200, 41);
                doc.line(200, 11, 200, 41);
                doc.setFontSize(10);
        
            

                doc.autoTable({
                 theme: 'grid',     
                columns: columns,
                body: this.desserts3,
                startY: 48,
                margin: { top: 25, left: 10, right: 10 },
                styles: { fontSize: 7 },          
                });

                var finalO =  doc.autoTable.previous.finalY + 30;

                if (finalO >= 285) {
                    doc.addPage();
                    finalO = 0;
                }


        

          
                doc.setFontSize(11);
                
        
                doc.text("Lugar de Entrega:  " + vm.desserts3[0].lugEnt  , 10,finalO + 20 );            
                doc.text("Ítems con inspección del cliente y/o protocolos de ensayo:  " + vm.desserts3[0].itemIns ,10,finalO + 26 )          
                doc.text("Observaciones:  " + vm.desserts3[0].observa , 10,finalO + 32 );     
                doc.text("Responsable Tecnico:  "+ vm.desserts3[0].tecnico, 10,finalO+ 45);
                doc.text("Responsable Comercial:  "+ vm.desserts3[0].comercial, 10,finalO + 51);       

         
            
     
                const pageCount = doc.internal.getNumberOfPages();

                for (var i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.text(
                    "Página " + String(i) + " de " + String(pageCount),
                    210 - 20,
                    297 - 10,
                    null,
                    null,
                    "right"
                    );
                }

                doc.save('table.pdf');

           } 
        

        },


        ocultarSolicitud(){


            this.$router.push({ name: 'FichaOT' });


        },
        

        
    }


      

     



    
}
</script>

<style scoped>
.card-height {
  min-height: 150px; /* Ajusta la altura según tus necesidades */
}
</style>